import {FC} from "react";
import {ModalFooter} from "../../../layout/ModalProvider";
import {useApiCall} from "../../../../api";
import {TeamSpaceItem} from "../../../../api/repositories/documentation-library-repository";
import {ConfigInterface} from "../../../../config";

export const DeletePageModal: FC<{ config: ConfigInterface, item: TeamSpaceItem, onDeleted: (page: TeamSpaceItem) => void }> = (props) => {
  const { documentations } = useApiCall(props.config)
  const confirm = async () => {
    await documentations.deletePage(props.item.id)
    props.onDeleted(props.item)
  }

  return <div>
    <div>Weet je zeker dat je deze pagina definitief wilt verwijderen?</div>
    <ModalFooter text={'Verwijderen'} onSubmit={confirm} />
  </div>
}